import React from 'react'
import PropTypes from 'prop-types'
import { REFI_BULLETS } from 'src/constants/refinance'
import { InlineTextLock } from 'src/Components'
import Format from 'src/Components/shared/Format'
import Bullet from './Bullet'
import isARM from './isARM'
import { baseProps, deltaProps, PMI } from './Shapes'

const ShortBullets = ({
  type,
  years,
  longterm,
  shortterm,
  pmi,
  yearsInHome,
  locked
}) => {
  const bullets = []
  let key

  if (isARM(type)) {
    key = 'arm_'
    if (years > yearsInHome) {
      key += 'good'
    } else {
      key += 'bad'
    }
  } else {
    key = 'fix_'
    if (longterm > 0) {
      key += 'good'
    } else {
      key += 'bad'
    }
  }

  bullets.push(
    <Bullet key={key} refiMessage={REFI_BULLETS[key]} values={{ years }} />
  )

  if (pmi) {
    bullets.push(
      <Bullet
        key='pmi'
        refiMessage={REFI_BULLETS.pmi}
        values={{
          pmi: (
            <InlineTextLock enabled={locked}>
              <Format.Currency value={pmi} />
            </InlineTextLock>
          )
        }}
      />
    )
  } else {
    key = 'short_'
    if (shortterm < 0) {
      key += 'good'
    } else if (shortterm > 0) {
      key += 'bad'
    } else {
      key += 'same'
    }

    bullets.push(
      <Bullet
        key={key}
        refiMessage={REFI_BULLETS[key]}
        values={{
          abs_shortterm: (
            <InlineTextLock enabled={locked}>
              <Format.Currency value={Math.abs(shortterm)} />
            </InlineTextLock>
          )
        }}
      />
    )
  }

  return bullets
}

ShortBullets.propTypes = {
  ...baseProps,
  ...deltaProps,
  pmi: PMI,
  yearsInHome: PropTypes.number,
  locked: PropTypes.bool
}

export default ShortBullets
